module.exports = __webpack_public_path__ + "static/js/upload worker.9d89e333.chunk.worker.js"